import React from 'react'
import { Row, Col, FormGroup, Label, Input, Button, FormFeedback, Alert, Spinner } from 'reactstrap'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { handleSubmitCreateCompanyDetails } from '../actions/companyActions'
import PageContainer from '../Shared/LayoutComponents/PageContainer'
import HeaderRow from '../Shared/LayoutComponents/HeaderRow'
import PageHeading from '../Shared/LayoutComponents/PageHeading'
import styled from 'styled-components'

const registerSchema = Yup.object().shape({
  applicationID: Yup.string().required('Application ID is Required'),
  applicationSecret: Yup.string().required('Application Secret is Required'),
  directoryID: Yup.string().required('Tenant ID is Required'),
})

let StyledLabel = styled(Label)`
  font-weight: 500;
`

const CreateCompanyDetails = (props) => {
  return (
    <PageContainer>
      <HeaderRow center>
        <PageHeading>3. Enter Azure AD Credentials</PageHeading>
      </HeaderRow>
      <HeaderRow small center>
        <h5>{props.createSelected ? props.createSelected.label : null}</h5>
      </HeaderRow>
      <Row>
        <Col sm={0} md={2}></Col>
        <Col sm={12} md={8}>
          <Formik
            initialValues={{ applicationID: '', applicationSecret: '', directoryID: '' }}
            onSubmit={async (values, { setSubmitting, setStatus }) => {
              try {
                await props.handleSubmitCreateCompanyDetails(values)
                setSubmitting(false)
              } catch (err) {
                setSubmitting(false)
                setStatus({ msg: err })
              }
            }}
            validationSchema={registerSchema}
          >
            {(props) => {
              const { touched, errors, isSubmitting, handleChange, handleBlur, handleSubmit, status } = props
              return (
                <form onSubmit={handleSubmit}>
                  <FormGroup row>
                    <StyledLabel sm={3} for="applicationID">
                      Application (client) ID:
                    </StyledLabel>
                    <Col sm={9}>
                      <Input
                        invalid={errors.applicationID && touched.applicationID ? true : false}
                        type="text"
                        name="applicationID"
                        id="applicationID"
                        placeholder="Enter Application ID"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <FormFeedback>{errors.applicationID}</FormFeedback>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <StyledLabel sm={3} for="directoryID">
                      Directory (tenant) ID:
                    </StyledLabel>
                    <Col sm={9}>
                      <Input
                        invalid={errors.directoryID && touched.directoryID ? true : false}
                        type="text"
                        name="directoryID"
                        id="directoryID"
                        placeholder="Enter Directory ID"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <FormFeedback>{errors.directoryID}</FormFeedback>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <StyledLabel sm={3} for="applicationSecret">
                      Application Secret:
                    </StyledLabel>
                    <Col sm={9}>
                      <Input
                        invalid={errors.applicationSecret && touched.applicationSecret ? true : false}
                        type="password"
                        name="applicationSecret"
                        id="applicationSecret"
                        placeholder="Enter Application Secret"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <FormFeedback>{errors.applicationSecret}</FormFeedback>
                    </Col>
                  </FormGroup>
                  {status && (
                    <Alert color="danger">
                      Error validating Azure AD Credentials
                      <br />
                      {status.msg}
                    </Alert>
                  )}
                  <div>
                    <Link to="/Create/Agreement">
                      <Button outline color="secondary">
                        Back
                      </Button>
                    </Link>{' '}
                    <Button className="float-right" type="submit" disabled={isSubmitting} color="primary">
                      {isSubmitting ? (
                        <span>
                          <Spinner style={{ height: '1.15rem', width: '1.15rem' }} color="light" /> Validating
                        </span>
                      ) : (
                        'Validate'
                      )}
                    </Button>
                  </div>
                </form>
              )
            }}
          </Formik>
        </Col>
        <Col sm={0} md={1}></Col>
      </Row>
    </PageContainer>
  )
}

const mapStateToProps = (state) => ({
  createSelected: state.company.createSelected,
})

const mapDispatchToProps = {
  handleSubmitCreateCompanyDetails,
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateCompanyDetails)
